import LoadingScreen from 'components/LoadingScreen';
import PageLayout from 'components/PageLayout';
import ActiveFiltersBar from 'components/SearchAndFilters/SelectedFiltersBar';
import { useAtomValue, useSetAtom } from 'jotai';
import React, { Suspense } from 'react';
import { Row, Col, CardTitle } from 'reactstrap';
import DashboardActions from './DashboardActions';
import EPDataGrid from './EPDataGrid';
import EPInsights from './EPInsights';
import Filters from './Filters';
import { useFilterConfig } from './Filters.config';
import {
  epListingDataAtom,
  filterValuesAtom,
  useOnFilterChangeResetAtoms,
} from './state';
const SelectedFilters: React.FC<{ filtersConfig }> = ({ filtersConfig }) => {
  const setFilterValues = useSetAtom(filterValuesAtom);
  const resetOnFilterChangeAtoms = useOnFilterChangeResetAtoms();
  return (
    <Suspense fallback={<></>}>
      <ActiveFiltersBar
        filtersConfig={filtersConfig}
        onFiltersReset={() => {
          setFilterValues({ ...filtersConfig.getActiveFilterValues() });
          resetOnFilterChangeAtoms();
        }}
      />
    </Suspense>
  );
};

const ListingCount: React.FC = () => {
  const listingData = useAtomValue(epListingDataAtom);
  return <>{listingData?.loading ? '...' : listingData.count}</>;
};

function EPListing() {
  const filtersConfig = useFilterConfig();
  return (
    <PageLayout
      id="endpoints_listing"
      heading={
        <Row>
          <Col md="auto" sm="12">
            <CardTitle>
              <h4>
                Endpoints
                <label id="counts" className="label btn">
                  <Suspense fallback={<>...</>}>
                    <ListingCount />
                  </Suspense>
                </label>
              </h4>
            </CardTitle>
          </Col>
        </Row>
      }
      subheading="List of Endpoints."
      filteringOptions={<Filters filtersConfig={filtersConfig} />}
    >
      <Suspense fallback={<LoadingScreen />}>
        <div className="container-fluid p-0">
          <div className="row mb-1">
            {/* Expanding Column */}
            <div className="col">
              <SelectedFilters filtersConfig={filtersConfig} />
            </div>
            <div className="col-auto text-right align-baseline">
              <Suspense fallback={<>...</>}>
                <DashboardActions />
              </Suspense>
            </div>
          </div>
          <Suspense fallback={<LoadingScreen />}>
            <EPInsights />
          </Suspense>
          <Suspense fallback={<LoadingScreen />}>
            <EPDataGrid />
          </Suspense>
        </div>
      </Suspense>
    </PageLayout>
  );
}

const EPList = () => {
  return (
    <Suspense fallback={<LoadingScreen height={550} />}>
      <EPListing />
    </Suspense>
  );
};
export default EPList;
